import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DownIcon, Info, UpIcon } from "../../assets";
import BarChart from "../Charts/Bar";
import { getDataSource } from "../../services/api";
import { handleImageError } from "../../utils/common";

const CandidateCard = ({ candidate, party, translation }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const {
    candidateName,
    candidateAge,
    candidateImageUrl,
    votes,
    residenceCity,
    localMandate,
    nationalMandate1,
    nationalMandate2,
    nationalMandate3,
    nationalMandate4,
    nationalMandate5,
  } = candidate;
  const [detailsVisible, setDetailsVisible] = useState(false);
  const hasVotes = votes && votes.length > 0;
  const transformedTranslation = translation.reduce((acc, obj) => {
    acc[obj.de] = obj;
    return acc;
  }, {});

  useEffect(() => {
    window.wort.frameResize();
  }, [detailsVisible]);

  return (
    <div className="flex flex-col rounded bg-wort border border-transparent hover:border-gray-300 transition-all duration-300 group">
      <div className="flex flex-row">
        <img
          src={`${getDataSource()}/portraits-legislative/${party}/${candidateImageUrl}.webp`}
          alt={candidateName}
          onError={handleImageError}
          className="w-[48px] h-[48px] rounded-l-sm"
        />

        <div className="flex flex-col px-2 w-full">
          <div
            className="flex flex-row justify-between cursor-pointer"
            onClick={() => setDetailsVisible(!detailsVisible)}
          >
            <span className="ml-2 mt-2">{candidateName}</span>
            {detailsVisible ? (
              <UpIcon
                className="w-5 h-[11px] ml-2 mt-3"
                onClick={() => setDetailsVisible(false)}
              />
            ) : (
              <DownIcon
                className="w-5 h-[11px] ml-2 mt-3 transition-transform duration-300 group-hover:rotate-180"
                onClick={() => setDetailsVisible(true)}
              />
            )}
          </div>
          {detailsVisible && (
            <div className="h-0.5 bg-black bg-opacity-30 mt-[12px]"></div>
          )}
        </div>
      </div>
      {detailsVisible && (
        <div className="flex flex-col px-3 pt-4 pb-2" id="detail-section">
          <div>
            <span className="ml-2 mt-2">{t("age")}:</span>
            <span className="ml-2 mt-2 font-semibold">
              {candidateAge === "Nicht mitgeteilt"
                ? transformedTranslation?.[candidateAge]?.[language]
                : candidateAge}{" "}
              {candidateAge === "Nicht mitgeteilt" ? "" : t("years")}
            </span>
          </div>
          <div>
            <span className="ml-2 mt-2">{t("residence")}:</span>
            <span className="ml-2 mt-2 font-semibold">
              {transformedTranslation?.[residenceCity]?.[language] ||
                residenceCity}
            </span>
          </div>

          <div>
            <span className="ml-2 mt-2">{t("localMandates")}:</span>
            <span className="ml-2 mt-2 font-semibold">
              {localMandate
                ? transformedTranslation?.[localMandate]?.[language]
                : t("none")}
            </span>
          </div>

          {nationalMandate1 && (
            <span className="mt-4 ml-2">
              {t("function")}:{" "}
              {transformedTranslation?.[nationalMandate1]?.[language]}
            </span>
          )}
          <ul className="list-disc ml-8">
            {/* {nationalMandate1 && <li className="mt-2">{nationalMandate1}</li>} */}
            {nationalMandate2 && (
              <li className="mt-2">
                {transformedTranslation?.[nationalMandate2]?.[language]}
              </li>
            )}
            {nationalMandate3 && (
              <li className="mt-2">
                {transformedTranslation?.[nationalMandate3]?.[language]}
              </li>
            )}
            {nationalMandate4 && (
              <li className="mt-2">
                {transformedTranslation?.[nationalMandate4]?.[language]}
              </li>
            )}
            {nationalMandate5 && (
              <li className="mt-2">
                {transformedTranslation?.[nationalMandate5]?.[language]}
              </li>
            )}
          </ul>

          <div className="bg-white rounded mt-3">
            <div className="px-2 pt-3">
              {!hasVotes && (
                <div className="flex flex-row pb-2">
                  <Info />
                  <span className="leading-6 ml-2">{t("firstCandidate")}</span>
                </div>
              )}
              {hasVotes && (
                <span className="font-medium leading-6">
                  {t("pastCandidacy")}
                </span>
              )}
              {hasVotes && (
                <div className="flex flex-col mt-3">
                  <div className="flex items-center mb-1">
                    <div className="w-4 h-3 bg-gray-300 mr-2" />
                    <span className="text-xs">{t("noCandidacy")}</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-4 h-3 bg-chart mr-2" />
                    <span className="text-xs">{t("obtainedVotes")}</span>
                  </div>
                </div>
              )}
            </div>
            {hasVotes && (
              <div className="h-[250px] lg:h-[250px] pt-3">
                <BarChart data={votes} className="h-full" />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CandidateCard;
